/**
 * Shared background-image chevron for every chip-styled `<select>` in this folder (Status,
 * Category, Priority) — positioned via `background-position` rather than the browser's own native
 * select arrow, whose inset isn't controllable to match the chips' own text padding. One constant
 * so the three controls read as one family instead of drifting apart.
 */
export const SELECT_CHEVRON =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10' fill='none'%3E%3Cpath d='M2.5 4L5 6.5L7.5 4' stroke='%23707070' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";
